import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleSpacerSpecification extends FlexibleBaseSpecification {
	id: number;
	vertical: string;
	horizontal: string;
}

export class FlexibleSpacerModel extends FlexibleModelBase {
	public readonly vertical: string;
	public readonly horizontal: string;

	constructor(spec: FlexibleSpacerSpecification) {
		super(spec);

		this.vertical = spec.vertical;
		this.horizontal = spec.horizontal;
	}
}
